<template>
  <div>
    <loading-screen v-if="isLoading" />
    <div class="p-6 text-gray-900 bg-white rounded-lg text-left font-medium shadow-lg">
      <h1 class="font-semibold text-xl">
        <fa-icon
          :icon="['fas', 'tachometer']"
          size="lg"
          class="mr-1 text-blue-400"
        />
        {{ $t("Overview", "Overview") }}
      </h1>
      <div class="flex ml-4 mt-2">
        <date-filter />
        <project-filter />
      </div>
      <quota-usage
        :start-date="overview.periodStartedAt"
        :end-date="overview.periodEndsAt"
        :quota="subscription.quota"
        :used-quota="overview.usedQuota"
        class="w-full my-8"
      />
      <div class="charts-container">
        <div class="flex w-full chart-row">
          <div class="w-1/2">
            <content-loader
                v-if="overview.numberOfCalls === null"
                :height="250"
                :width="300"
                :speed="5"
                primary-color="#f3f3f3"
                secondary-color="#aaaaaa"
                class="m-3"
            />
            <stacked-column-chart
              v-if="overview.numberOfCalls !== null"
              :chart-data="overview.numberOfCalls"
              :parse-date="true"
            />
          </div>
          <div class="w-1/2">
            <content-loader
                v-if="overview.averageResponseTime === null"
                :height="250"
                :width="300"
                :speed="5"
                primary-color="#f3f3f3"
                secondary-color="#aaaaaa"
                class="m-3"
            />
            <time-series
              v-if="overview.averageResponseTime !== null"
              :chart-data="overview.averageResponseTime"
              :title="$t('Average response time', 'Average response time')"
            />
          </div>
        </div>
        <div class="flex w-full chart-row">
          <div class="w-1/2">
            <content-loader
                v-if="overview.averageCharacterCount === null"
                :height="250"
                :width="300"
                :speed="5"
                primary-color="#f3f3f3"
                secondary-color="#aaaaaa"
                class="m-3"
            />
            <time-series
                v-if="overview.averageCharacterCount !== null"
                :chart-data="overview.averageCharacterCount"
                :title="$t('Average character count', 'Average character count')"
            />
          </div>
          <div class="w-1/2">
            <content-loader
                v-if="overview.characterCount === null"
                :height="250"
                :width="300"
                :speed="5"
                primary-color="#f3f3f3"
                secondary-color="#aaaaaa"
                class="m-3"
            />
            <time-series
                    v-if="overview.characterCount !== null"
                    :chart-data="overview.characterCount"
                    :title="$t('Character count', 'Character count')"
            />
          </div>
        </div>
      </div>
      <div class="flex">
        <pie-chart
          v-if="overview.ipBreakdown !== null"
          :chart-data="overview.ipBreakdown"
          :title="$t('overview.ipbreakdown.title', 'Calls by client IP address')"
          :category-name="$t('overview.ipbreakdown.categoryname', 'Client IPs')"
          class="w-1/3"
        />
        <div
          v-else
          class="w-1/3"
        />
        <pie-chart
          v-if="overview.langBreakdown !== null"
          :chart-data="overview.langBreakdown"
          :title="$t('overview.langBreakdown.title', 'Calls by analyzed language')"
          :category-name="$t('overview.langBreakdown.categoryname', 'Languages')"
          class="w-1/3"
        />
        <div
          v-else
          class="w-1/3"
        />
        <pie-chart
          v-if="overview.endpointBreakdown !== null"
          :chart-data="overview.endpointBreakdown"
          :title="$t('overview.endpointBreakdown.title', 'Calls by API endpoints')"
          :category-name="$t('overview.endpointBreakdown.categoryname', 'API endpoints')"
          class="w-1/3"
        />
        <div
          v-else
          class="w-1/3"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { actionNames } from '@/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTachometer } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import StackedColumnChart from './components/StackedColumnChart'
import TimeSeriesChart from './components/TimeSeriesChart'
import PieChart from './components/PieChart'
import QuotaUsage from './components/QuotaUsage'
import DateFilter from '@/overview/components/DateFilter'
import ProjectFilter from '@/overview/components/ProjectFilter'
import { ContentLoader } from 'vue-content-loader'
import LoadingScreen from '@/global/ui/LoadingScreen'

library.add(faTachometer)
export default {
  name: 'Overview',
  components: {
    ProjectFilter,
    DateFilter,
    'fa-icon': FontAwesomeIcon,
    StackedColumnChart,
    'time-series': TimeSeriesChart,
    'pie-chart': PieChart,
    'quota-usage': QuotaUsage,
    ContentLoader,
    LoadingScreen
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      subscription: state => state.profile.subscription,
      overview: state => state.overview
    })
  },
  mounted () {
    this.isLoading = true
    this.$store.dispatch(actionNames.INIT_OVERVIEW)
    this.$store.dispatch(actionNames.INIT_SUBSCRIPTION)
    this.$store.dispatch(actionNames.INIT_PROJECTS)
    this.isLoading = false
  }
}
</script>
<style>
@media (min-width: 1920px) {
  .charts-container {
    display: flex;
  }
  .chart-row {
    width: 50%;
  }
}
</style>
